
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import BadgeDisplay from './BadgeDisplay';
import LevelDisplay from './LevelDisplay';
import { useUserStats } from '@/hooks/useUserStats';
import { AVAILABLE_BADGES, getEarnedBadges, getNextLevelProgress } from '@/utils/badgeSystem';

const MemberBadges = () => {
  const userStats = useUserStats();

  if (userStats.isLoading) {
    return (
      <div className="flex justify-center items-center h-32">
        <div className="w-6 h-6 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  const earnedBadges = getEarnedBadges(userStats);
  const levelProgress = getNextLevelProgress(userStats.totalPoints);

  return (
    <div className="space-y-6">
      <LevelDisplay
        currentLevel={levelProgress.currentLevel}
        nextLevel={levelProgress.nextLevel}
        progress={levelProgress.progress}
        points={userStats.totalPoints}
      />

      <Card>
        <CardHeader>
          <CardTitle>我的勳章</CardTitle>
        </CardHeader>
        <CardContent>
          {earnedBadges.length > 0 ? (
            <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 mb-6">
              {earnedBadges.map((badge) => (
                <BadgeDisplay key={badge.id} badge={badge} earned={true} />
              ))}
            </div>
          ) : (
            <p className="text-gray-500 text-center py-4">還沒有獲得任何勳章</p>
          )}

          <div className="border-t pt-4">
            <h4 className="font-medium mb-3 text-gray-700">所有勳章</h4>
            <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {AVAILABLE_BADGES.map((badge) => {
                const earned = earnedBadges.some(eb => eb.id === badge.id);
                return (
                  <BadgeDisplay
                    key={badge.id}
                    badge={badge}
                    earned={earned}
                    size="sm"
                  />
                );
              })}
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>會員統計</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <div className="text-2xl font-bold text-blue-600">{userStats.reviewCount}</div>
              <div className="text-sm text-gray-500">發表評論</div>
            </div>
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <div className="text-2xl font-bold text-green-600">{earnedBadges.length}</div>
              <div className="text-sm text-gray-500">獲得勳章</div>
            </div>
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <div className="text-2xl font-bold text-purple-600">{userStats.memberDays}</div>
              <div className="text-sm text-gray-500">加入天數</div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default MemberBadges;
